export const hasObjectValue = <T>(value: T | undefined | null): value is T => {
  return !!value && Object.values(value).some((v) => v !== undefined && v !== null);
};

export const excludeNullishDataKeys = <T>(obj: Record<string, T | undefined | null>): Record<string, T> => {
  return Object.fromEntries(Object.entries(obj).filter(([_, value]) => value !== undefined && value !== null)) as Record<string, T>;
};

export const excludeKeys = <T>(obj: Record<string, T>, keys: string[]): Record<string, T> => {
  return Object.fromEntries(Object.entries(obj).filter(([key]) => !keys.includes(key))) as Record<string, T>;
};
